import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "articleContentBox"
};
const _hoisted_2 = {
  class: "item-list"
};
const _hoisted_3 = {
  key: 0,
  class: "item"
};
const _hoisted_4 = {
  key: 1,
  class: "item"
};
const _hoisted_5 = {
  href: "",
  target: "_blank"
};
const _hoisted_6 = {
  key: 2,
  class: "item"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1);
const _hoisted_8 = ["innerHTML"];
import { ref, watch } from "vue";
import "github-markdown-css/github-markdown-light.css";
import { marked } from 'marked';
export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleContent',
  props: {
    articleDetail: {},
    dictList: {}
  },
  setup(__props) {
    const articleType = ref('');
    const formatterContent = ref('');
    const props = __props;
    watch([() => props.articleDetail, () => props.dictList], ([newVal, newDictList]) => {
      if (newVal && newVal.content) {
        //markdown格式转为html格式
        const content = marked.parse(newVal.content);
        formatterContent.value = content;
      }
      if (newVal && newDictList) {
        const dic = newDictList.find(item => Number(item.dictValue) === Number(newVal.type));
        articleType.value = dic?.dictLabel;
      }
    });
    return (_ctx, _cache) => {
      const _directive_highlight = _resolveDirective("highlight");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("h1", null, _toDisplayString(_ctx.articleDetail.title), 1), _createElementVNode("div", _hoisted_2, [_ctx.articleDetail.type != null ? (_openBlock(), _createElementBlock("div", _hoisted_3, "分类: " + _toDisplayString(articleType.value), 1)) : _createCommentVNode("", true), _ctx.articleDetail.author ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createTextVNode("作者: "), _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.articleDetail.author), 1)])) : _createCommentVNode("", true), _ctx.articleDetail.updateTime ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.articleDetail.updateTime), 1)) : _createCommentVNode("", true)]), _hoisted_7, _withDirectives(_createElementVNode("div", {
        class: "markdown-body",
        innerHTML: formatterContent.value
      }, null, 8, _hoisted_8), [[_directive_highlight]])]);
    };
  }
});